export const FILTER_ALPHABET = 'alphabet'
export const FILTER_OCCURENCE = 'occurence'
